module.exports = __webpack_public_path__ + "static/thanx-screens-ba9adc0f59658b037428d9d310391a0b.png";